/* eslint-disable @typescript-eslint/no-explicit-any */

export function reduceWithSum(arr: number[]): number;
export function reduceWithSum<T>(arr: T[], selector: (curr: T) => number): number;

export function reduceWithSum(arr: any[], selector?: (curr: any) => number): number {
    const get = selector ?? ((curr) => curr);
    return arr.reduce((sum, curr) => sum + get(curr), 0);
}
export function groupBy<T>(array: T[], selectKey: (item: T) => PropertyKey): Record<PropertyKey, T[]> {
    return array.reduce(
        (coll, curr) => {
            const key = selectKey(curr);
            if (!(key in coll))
                coll[key] = [];

            coll[key].push(curr);
            return coll;
        },
        {} as Record<PropertyKey, T[]>,
    );
}

export function indexOf<T>(array: T[], predicate: (element: T) => boolean): number {
    for (let i = 0; i < array.length; i++) {
        if (predicate(array[i]))
            return i;
    }

    return -1;
}

export function shiftBy<T>(array: T[], amount: number): T[] {
    if (array.length === 0)
        return [];

    if (amount < 0) // allow shifting to right
        amount = array.length + amount;

    const result = [];

    for (let i = amount; i < array.length; i++)
        result.push(array[i]);

    for (let i = 0; i < amount; i++)
        result.push(array[i]);
    return result;

}

function arrayFirst<T>(this: T[]): T | undefined {
    return this[0];
}

function arrayLast<T>(this: T[]): T | undefined {
    return this[this.length - 1];
}

// eslint-disable-next-line no-extend-native
Object.defineProperty(Array.prototype, 'first', {
    get: arrayFirst,
});

// eslint-disable-next-line no-extend-native
Object.defineProperty(Array.prototype, 'last', {
    get: arrayLast,
});